import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  IdItemProcesso: number;
  IdItemProcessoFator: number;
};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;

};


export const initialFiltersValues: State = {
  IdItemProcesso: 0,
  IdItemProcessoFator: 0,
};

export const useItemProcessosFatorFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));